import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "../../../components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        language: "",
        title: "",
        content: "",
        cover: "",
        id: "",
        type_id: "",
        top: 0,
        state: 1,
        author: '',
        game_type: '',
        is_banner: 0,
        is_timing: '',
        timing: '',
        comment_type: 0
      },
      dialogShow: false,
      iconfileList: [],
      picfileList: [],
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        type_id: [{
          required: true,
          message: "请选择类型",
          trigger: "blur"
        }],
        top: [{
          required: true,
          message: "请选择是否指定",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        author: [{
          required: true,
          message: "请输入作者",
          trigger: "blur"
        }],
        game_type: [{
          required: true,
          message: "请选择公告类型",
          trigger: "blur"
        }],
        banner_title: [{
          required: true,
          message: "请输入轮播图标题",
          trigger: "blur"
        }],
        cover: [{
          required: true,
          message: "请上传轮播图",
          trigger: "blur"
        }],
        is_banner: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        is_timing: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        timing: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      },
      announceTypeList: [],
      timingList: [{
        label: "否",
        value: 0
      }, {
        label: "是",
        value: 1
      }]
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                _this.$api.announceTypeList().then(function (res) {
                  if (res.code == 0) {
                    _this.announceTypeList = res.data;
                  }
                }); // Base64.decode(data.content)


                if (data) {
                  console.log("data====", data);
                  _this.form = {
                    id: data.id,
                    type_id: data.type_id,
                    title: data.title,
                    cover: data.cover,
                    top: data.top,
                    content: _this.$utils.textRepl(data.content),
                    author: data.author,
                    state: data.state,
                    language: data.language,
                    game_type: data.game_type,
                    banner_title: data.banner_title,
                    is_banner: data.is_banner,
                    is_timing: data.is_timing,
                    timing: data.timing ? data.timing * 1000 : null,
                    comment_type: data.comment_type
                  };
                  _this.picfileList = data.cover ? [data.cover] : []; // console.log("this.$times.timestampToTime(data.timing)",this.$times.timestampToTime(data.timing))
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    announceTypeChange: function announceTypeChange(e) {
      var data = this.announceTypeList.filter(function (item) {
        return item.id == e;
      });
      this.form.language = data[0].language;
    },
    onEditorChange: function onEditorChange(e) {
      this.form.content = e;
    },
    imgChange: function imgChange(e) {
      this.picfileList = e;
      this.form.cover = e[0] && e[0].response ? e[0].response.data : '';
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        type_id: "",
        title: "",
        cover: "",
        content: "",
        state: 1,
        top: 0,
        is_banner: 0,
        language: '',
        author: '',
        game_type: '',
        is_timing: '',
        timing: ''
      };
      this.picfileList = [];
      this.$refs.ruleForm.resetFields();
    },
    isTimeChange: function isTimeChange(val) {
      if (val == 0) {
        this.form.timing = "";
      }
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.content = data.content.replaceAll(_this2.$imgUrl, '');
          data.timing = data.timing ? data.timing / 1000 : "";
          var reqFn = _this2.form.id ? 'updAnnounce' : 'addAnnounce';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};